<div
    class="mx-auto mb-4 w-full max-w-(--breakpoint-xl) rounded-2xl bg-white p-6 shadow-lg">
    <ng-content></ng-content>
</div>
